module.exports = __webpack_public_path__ + "img/diamond_watch.e36f4ca7.png";